import React from 'react';
import { LTText } from '@lambdatestincprivate/lt-components';
import styles from './AIRca.module.css';

const RCAFixSection = ({ sections }) => {
  if (!Array.isArray(sections) || sections.length === 0) return null;

  return (
    <div className={styles.fixContainer}>
      <div className={styles.fixHeader}>
        <LTText variant={LTText.TextVariant.SUBHEADER_BOLD} color="text.muted">
          How to fix it
        </LTText>
      </div>
      <div className={styles.fixBox}>
        {sections.map((fix, index) => (
          <div key={index} className={styles.fixItem}>
            <LTText
              text={`${index + 1}.`}
              variant={LTText.TextVariant.SUBHEADER_REGULAR}
              color="#6B7280"
            />
            <div className={styles.fixContent}>
              <LTText
                variant={LTText.TextVariant.SUBHEADER_REGULAR}
                color="#111827"
              >
                {fix.issue}
              </LTText>
              {fix.suggested_fix && (
                <LTText
                  variant={LTText.TextVariant.SUBHEADER_REGULAR}
                  color="#374151"
                >
                  {fix.suggested_fix}
                </LTText>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RCAFixSection;
